import React from 'react';
// Constants
import { CompanyName, KeywordsPages, MainTitle } from '../../utils/Constants';
// Data
import {
  galleryPageAdditionalMeta,
  galleryPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GalleryPageMainContainer from '../../components/gallery/GalleryPageMainContainer';

function GalleryPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Gallery'
        desc='A visual journey into Lady Cinder’s neon-gothic world — fire, hypnosis, and celestial elegance.'
        keywords='Lady Cinder gallery, neon gothic dominatrix, fire eater, hypnosis visuals'
        additionalMeta={galleryPageAdditionalMeta}
        structuredData={galleryPageStructuredData}
      />

      {/* Page */}
      <div className='grid relative min-h-screen font-poppins bg-colour2 text-colour1 dark:text-colour1'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />
          <header className="grid py-10 px-6 text-center gap-4 place-items-center">
            <h1 className='neon_text_heavy_redpink font-titleFont text-4xl md:text-6xl tracking-wider drop-shadow-lg'>
              Gallery of Sin
            </h1>
            <div className='mx-auto grid justify-center'>
              <h2 className=''>{CompanyName}</h2>
            </div>
            <div className='mx-auto grid justify-center'>
              <p>{MainTitle}</p>
            </div>
          </header>

          {/* Main page content */}
          <GalleryPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default GalleryPage;
